import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useGetExperiment } from '../../../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION } from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import {
  ProductVolumePricingModal,
  useProductVolumePricingContext,
} from '../../../../../product'
import { ProductSearchResultItemGenericLabel } from '../ProductSearchResultItemGenericLabel'

export const ProductSearchResultItemVolumePricingLabel: FC = () => {
  const { openableControls } = useProductVolumePricingContext()
  const isMarketplaceHarmonisationEnabled =
    useGetExperiment(EXPERIMENT_NAME_MARKETPLACE_HARMONISATION).variant ===
    EXPERIMENT_VARIATION.V1

  return (
    <>
      <ProductSearchResultItemGenericLabel
        className={clsx(
          'border-light-primary-strong text-dark-primary-max',
          isMarketplaceHarmonisationEnabled
            ? 'bg-light-tertiary'
            : 'bg-light-brand-medium',
        )}
        data-qa-id="volume-pricing-modal-button"
        name="productLabelVolumePricing"
        onClick={openableControls.handleOpen}
      >
        <>
          <FormattedMessage id="volumePricing.modal.title" />
          <IconInfo className="ml-2 size-4" />
        </>
      </ProductSearchResultItemGenericLabel>
      <ProductVolumePricingModal />
    </>
  )
}
